import { useMutation } from "@tanstack/react-query"

import api from "../../services";

import cookiesHelper from "../../helpers/cookies";

import useToast from "../useToast";

export interface IArchiveJobPostsPayload {
    setIsProcessing: React.Dispatch<React.SetStateAction<boolean>>;
    setErrorMessage: React.Dispatch<React.SetStateAction<string | null>>;
    payload: {
        ids: number[];
    }
}

const useArchiveJobPosts = () => {
    const { addToast } = useToast();

    const mutationFn = async (variables: IArchiveJobPostsPayload) => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const { payload } = variables;

        const response = await api.patch('/job-posts/archive/multiple', payload);

        return response.data;
    }

    return useMutation({
        mutationFn,
        onMutate: (variables) => {
            const { setIsProcessing, setErrorMessage } = variables;
            setIsProcessing(true);
            setErrorMessage(null);
        },
        onSuccess: (_, variables) => {
            const { setIsProcessing, setErrorMessage } = variables;
            setIsProcessing(false);
            setErrorMessage(null);
        },
        onError: (error: any, variables) => {
            const { setIsProcessing, setErrorMessage } = variables;
            setIsProcessing(false);

            addToast({
                type: 'error',
                title: 'An error occurred while archiving job posts',
            });

            setErrorMessage(error?.response?.data?.message || 'An error occurred while archiving job posts');
        }
    })
}

export default useArchiveJobPosts;